<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("BUTTONS.view_notification_details") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #008274">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <!-- Start:: Title Ar Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.notification_title_ar')"
            v-model.trim="data.titleAr"
            disabled
          />
          <!-- End:: Title Ar Input -->

          <!-- Start:: Title En Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.notification_title_en')"
            v-model.trim="data.titleEn"
            disabled
          />
          <!-- End:: Title En Input -->

          <!-- Start:: Body Ar Input -->
          <base-input
            col="6"
            rows="7"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.notification_body_ar')"
            v-model.trim="data.bodyAr"
            disabled
          />
          <!-- End:: Body Ar Input -->

          <!-- Start:: Body En Input -->
          <base-input
            col="6"
            rows="7"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.notification_body_en')"
            v-model.trim="data.bodyEn"
            disabled
          />
          <!-- End:: Body En Input -->

          <!-- Start:: Send Date Input -->
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.send_date')"
            v-model.trim="data.sendDate"
            disabled
          />
          <!-- End:: Send Date Input -->

          <!-- Start:: Recipients Display -->
          <base-select-input
            v-if="data.recipients && data.recipients.length > 0"
            col="12"
            :optionsList="data.recipients"
            :placeholder="$t('PLACEHOLDERS.notification_recipients')"
            v-model="data.recipients"
            disabled
            multiple
          />
          <base-input
            v-else
            col="12"
            :placeholder="$t('PLACEHOLDERS.notification_recipients')"
            type="text"
            :value="$t('PLACEHOLDERS.all_users')"
            disabled
          />
          <!-- End:: Recipients Display -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "ShowNotification",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection
      data: {
        titleAr: null,
        titleEn: null,
        bodyAr: null,
        bodyEn: null,
        sendDate: null,
        recipients: [],
      },
      // End:: Data Collection
    };
  },

  methods: {
    // Start:: Get Notification Data
    async getNotificationData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `notifications/${this.$route.params.id}`,
        });

        const notificationData = res.data.data;

        this.data.titleAr = notificationData.title_ar || notificationData.title;
        this.data.titleEn = notificationData.title_en || notificationData.title;
        this.data.bodyAr = notificationData.body_ar || notificationData.body;
        this.data.bodyEn = notificationData.body_en || notificationData.body;
        this.data.sendDate = notificationData.created_at;

        // Handle recipients
        if (notificationData.recipients && notificationData.recipients.length > 0) {
          this.data.recipients = notificationData.recipients.map((user) => ({
            id: user.id,
            name: user.name || user.mobile || `User ${user.id}`,
          }));
        }
      } catch (error) {
        console.log(error.response?.data?.message);
        this.$message.error(
          error.response?.data?.message ||
            this.$t("MESSAGES.somethingWentWrong")
        );
      }
    },
    // End:: Get Notification Data
  },

  created() {
    // Start:: Fire Methods
    this.getNotificationData();
    // End:: Fire Methods
  },
};
</script>
